//import $ from 'jquery';

const
  NAME                 = 'dependentSelect',
  VERSION              = '1.0.0',
  JQUERY_NO_CONFLICT   = $.fn[NAME]
;

class DependentSelect {
  constructor(element$) {
    this._element$     = element$;
    this._elementAttr$ = $('#' + element$.data('voc-dependent-select'));

    this._elementAttr$.on('change', this.onChange.bind(this));
    this._elementAttr$.trigger('change');
  }

  onChange(/*event*/) {
    var idSection = this._elementAttr$.find('option:selected').data('id');
    this._element$.prop('disabled', false);

    this._element$.find('option').not(':first').each(function() {
      if (idSection !== $(this).data('id')) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new DependentSelect($(this));
    });
  }
}

$.fn[NAME]             = DependentSelect._jQueryInterface;
$.fn[NAME].Constructor = DependentSelect;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return DependentSelect._jQueryInterface;
};

export default DependentSelect;



// WEBPACK FOOTER //
// ./src/plugins/dependent-select.js